import styled from 'styled-components';

export const FieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: ${(props) => props.width || '100%'};
  max-width: ${(props) => props.maxWidth || 'none'};
  min-width: 0;
  box-sizing: border-box;

  /* Prevent children from expanding beyond container */
  > label,
  > input,
  > div {
    min-width: 0;
    max-width: 100%;
    box-sizing: border-box;
  }
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => (props.theme.name === 'dark' ? '#E5E7EB' : '#4B5563')};
`;

export const Required = styled.span`
  color: #ef4444;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding: 12px 14px;
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'};
  border: 1px solid
    ${(props) => {
      if (props.error) return '#ef4444';
      return props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.15)';
    }};
  border-radius: 6px;
  color: ${(props) => (props.theme.name === 'dark' ? '#ffffff' : '#1F2937')};
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:focus {
    border-color: ${(props) =>
      props.error ? '#ef4444' : props.theme?.colors?.primary || '#fa4616'};
    box-shadow: 0 0 0 3px
      ${(props) =>
        props.error ? 'rgba(239, 68, 68, 0.1)' : 'rgba(250, 70, 22, 0.1)'};
  }

  &::placeholder {
    color: ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255, 255, 255, 0.4)'
        : 'rgba(0, 0, 0, 0.4)'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Fix autofill background color in dark theme */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px
      ${(props) =>
        props.theme.name === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#ffffff'}
      inset !important;
    -webkit-text-fill-color: ${(props) =>
      props.theme.name === 'dark' ? '#ffffff' : '#1F2937'} !important;
    transition: background-color 5000s ease-in-out 0s;
  }
`;

export const HelperText = styled.div`
  margin-top: 6px;
  font-size: 13px;
  color: ${(props) => (props.error ? '#ef4444' : '#64748B')};
`;
